var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 1.71094C11.2793 1.71094 10.6219 2.0698 10.2518 2.69199L0.399798 19.2881C0.0297116 19.9121 0.0370753 20.6762 0.407896 21.2997C0.778901 21.9232 1.43366 22.2909 2.15584 22.289H21.8438C22.566 22.2916 23.2206 21.9232 23.5918 21.2997C23.9628 20.6762 23.9701 19.9121 23.5999 19.2881L13.7479 2.69152C13.378 2.06932 12.7204 1.71094 11.9998 1.71094Z",
    fill: "#63F8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 17.8703C10.5 17.0419 11.1716 16.3703 12 16.3703C12.8284 16.3703 13.5 17.0419 13.5 17.8703C13.5 18.6986 12.8284 19.3701 12 19.3701C11.1716 19.3701 10.5 18.6986 10.5 17.8703Z",
    fill: "#151515"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7522 13.7608L10.7522 8.81703L10.7522 8.81718C10.7522 8.37124 10.9901 7.95932 11.3761 7.73635C11.7622 7.51352 12.238 7.51352 12.6241 7.73635C13.0102 7.95932 13.248 8.37124 13.248 8.81718L13.248 13.761L13.248 13.7608C13.248 14.2067 13.0102 14.6187 12.6241 14.8417C12.238 15.0645 11.7622 15.0645 11.3761 14.8417C10.9901 14.6187 10.7522 14.2066 10.7522 13.7608Z",
    fill: "#151515"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/warning.4b7aba6b298b867ecd4317b156360196.svg";